/**
 * A label with a tooltip. Useful for labeling sub-pieces of a style
 * property that can't directly be reset (unlike with a `PropertyLabel`).
 */

import * as React from 'react';
import TooltipTrigger from '@packages/systems/design-system/TooltipTrigger';
import {unselectable} from '@packages/systems/design-system/constants/Styles';
import {useTheme} from '@packages/utilities/styled';

type StylePanelLabelProps = {
  style?: Record<any, any> | null | undefined;
  small?: boolean;
  centered?: boolean;
  muted?: boolean;
  tooltip?: React.ReactNode;
  children: React.ReactNode;
};
export const StylePanelLabel = ({
  children,
  small,
  muted,
  centered,
  tooltip,
  style,
}: StylePanelLabelProps) => {
  const theme = useTheme();
  return (
    <div
      style={{
        ...unselectable,
        ...(small ? theme.typography.labelSmall : theme.typography.label),
        color: muted ? theme.colors.foregroundDim : theme.colors.foreground,
        justifySelf: centered ? 'center' : 'start',
        fontWeight: 400,
        ...style,
      }}
    >
      {tooltip != null ? (
        <TooltipTrigger alternate content={tooltip}>
          <span>{children}</span>
        </TooltipTrigger>
      ) : (
        <span>{children}</span>
      )}
    </div>
  );
};
